module.exports = __webpack_public_path__ + "img/self_light.b76a50cd.png";